<template>

    <v-layout col justify-start>
      <v-flex xs10 mx-0>
        <v-autocomplete  v-model="rankWork.select" :items="rankWork.ranks" item-text="name" item-value="id"
          :label="prompt" :auto-select-first='true'
          :search-input.sync="rankSearch" :loading="rankWork.loading"   return-object  @change="rankChange()">     
        </v-autocomplete>
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delRank()'>delete</v-icon>
      </v-flex>
    </v-layout>    

</template>        

<script>
import RankService from "@/services/RankService" ;

export default {

  components: { RankService },
  props: {
    rank: null,    
    person: null,
    prompt: null
  },

  data () {
    return {
      addSeqForRid: -1,
      rankWork: {
        select: {id: -1, name: "", count: -1}, 
        serviceCode: null,
        ranks: [],
        loading: false,
        origId: -1,
        pendingSearch: null
      },
      rankSearch: null,
      serviceValues: ['Army', 'Merchant Navy', 'RAAF', 'RAN'],
      rankCodesForService: ['ra', 'rc', 'rd', 'rb']  
    }
  },

  watch: {

    async rankSearch (val) {
      if (val && val !== this.rankWork.select.name && (val.length >= 2)) 
        this.error = await this.executeRankSearch(val, this.rankWork) ;      
    }   
  },

  async created () {
    // console.log("IIIIIIIn editRank rank= " + JSON.stringify(this.rank)) ;
    this.updateRankSelectionFromRecord(this.rankWork, this.rank, this.person) ;
  },

  methods: {

    updateRankSelectionFromRecord (locp, dbr, dbPerson) {

      this.rankWork.serviceCode = null ;
      if (this.person && this.person.service) {
        const ix = this.serviceValues.indexOf(this.person.service) ;
        if (ix >= 0) this.rankWork.serviceCode = this.rankCodesForService[ix] ;
      }

      if (dbr && dbr.rid) {  
        locp.select.id = dbr.id ; 
        locp.select.name = dbr.v ;
        
        locp.origId =  locp.select.id ;
        locp.ranks = [ locp.select ] ;        
      }
    },

    async executeRankSearch (val, locp) {

      if (locp.loading) {
        console.log("executeRankSearch in progress - deferring " + val) ;
        locp.pendingSearch = val ;
        return ;
      }

      let searchErr = null ;

      console.log("rankQuerySelections val: " + val) ;
      locp.loading = true ;
      try {
        const response = await RankService.index(val, locp.serviceCode, 0, 1000) ;
        console.log("RankService responsed") ; // + JSON.stringify(response)) ;

        const d = response.data ;
        for (let i = 0 ; i < d.length ; i++) {
          const du = d[i] ;
          du.name += " - " + du.count + ((du.count === 1) ? " person" : " people") ;
        }
        locp.ranks = response.data ;
      }
      catch (err) {
        console.log("rankQuerySelections catch err:" + JSON.stringify(err)) ;
        searchErr = err.response.data.error ;
      }
      finally {
        locp.loading = false ;
      }

      if (locp.pendingSearch) {
        const queuedSearch = locp.pendingSearch ;
        locp.pendingSearch = null ;
        console.log("Queuing pending search.." + queuedSearch) ;
        const res = await this.executeRankSearch(queuedSearch, locp) ;
        return res ;
      }        
      else return searchErr ;      
    },

    rankChange () {
      console.log("---------------------------------rankChange: " + JSON.stringify(this.rankWork.select)) ;
      this.rank.newId = this.rankWork.select.id ;
    },

    delRank () {
      this.rank.newId = -1 ;
      this.rankWork.select.id = -1 ;
      this.rankWork.select.name = "*DELETED*" ;
      this.rankWork.ranks = [{id:-1, name:"*DELETED*"}] ;
    }
  } 
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Person/EditRank.vue